import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["frame", "status"]
  static values = { url: String }

  connect() {
    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return

        this.observer.disconnect()
        this.loadPreview()
      }, { rootMargin: "300px" })
      this.observer.observe(this.element)
    } else {
      this.loadPreview()
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.abortController) this.abortController.abort()
    this.releaseObjectUrl()
  }

  async loadPreview() {
    if (this.objectUrl || this.loading) return

    this.loading = true
    this.statusTarget.hidden = false
    this.statusTarget.textContent = "Chargement de l'aperçu…"
    this.abortController = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/pdf" },
        signal: this.abortController.signal
      })

      if (!response.ok) throw new Error(`PDF preview failed with status ${response.status}`)

      const pdf = await response.blob()
      this.objectUrl = URL.createObjectURL(pdf)
      this.frameTarget.addEventListener("load", () => this.hideStatus(), { once: true })
      this.frameTarget.src = this.objectUrl
    } catch (error) {
      if (error.name === "AbortError") return

      this.statusTarget.textContent = "L'aperçu intégré n'a pas pu être chargé. Utilisez le lien ci-dessus pour ouvrir le document."
      console.error(error)
    } finally {
      this.loading = false
      this.abortController = null
    }
  }

  hideStatus() {
    this.statusTarget.hidden = true
  }

  releaseObjectUrl() {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
